module.exports = __webpack_public_path__ + "static/img/partner-chelion.e25b7c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-chelion.png
// module id = 03g9
// module chunks = 34